import Home from "./components/Home/index";
import Admin from "./components/Admin/index";
// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  Link,
} from "react-router-dom";
import Login from "./components/Login/Login";
// import Portfolio from "./components/Portfolio/index";
// import Register from "./components/Register/Register";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/admin",
      element: <Admin />,
    },
    {
      path: "*",
      element: "ANJAY MANTAP",
    },
  ]);
  return (
    <div className="App overflow-hidden">
      {/* <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="*" element="NOT FOUND" />
        </Routes>
      </Router> */}
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
